import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { PageLayout, ExplorerView, NodesView, GraphView, ScopeView, getDomainConfig } from '@shared';

import Dashboard from './views/Dashboard';
import Library from './views/Library';
import DocDetail from './views/DocDetail';
import Upload from './views/Upload';
import Analyze from './views/Analyze';
import Search from './views/Search';
import Chat from './views/Chat';
import Agent from './views/Agent';
import Generate from './views/Generate';
import Convert from './views/Convert';
import PdfTools from './views/PdfTools';

const cfg = getDomainConfig('docbrain');

const SIDEBAR = [
  { label: 'Overview', icon: '\u25C9', children: [
    { label: 'Dashboard', path: '/' },
    { label: 'Bibliothek', path: '/library' },
    { label: 'Upload', path: '/upload' },
  ]},
  { label: 'KI-Analyse', icon: '\uD83E\uDDE0', children: [
    { label: 'Analyse', path: '/analyze' },
    { label: 'Chat', path: '/chat' },
    { label: 'Agent', path: '/agent' },
    { label: 'Suche', path: '/search' },
  ]},
  { label: 'Werkzeuge', icon: '\u2699\uFE0F', children: [
    { label: 'Generator', path: '/generate' },
    { label: 'Konverter', path: '/convert' },
    { label: 'PDF Tools', path: '/pdf-tools' },
  ]},
  { label: 'Explorer', icon: '\uD83D\uDCC2', children: [
    { label: 'Dateien', path: '/explorer' },
    { label: 'Editor', path: '/explorer/editor' },
    { label: 'Dokumente', path: '/explorer/docs' },
  ]},
  { label: 'Nodes', icon: '\uD83D\uDDA5', children: [
    { label: 'Geraete', path: '/nodes' },
  ]},
  { label: 'Graph', icon: '\uD83D\uDD17', children: [
    { label: 'Map', path: '/graph' },
  ]},
  { label: 'Scope', icon: '\uD83D\uDD0D', children: [
    { label: 'Sources', path: '/scope/sources' },
    { label: 'Facts', path: '/scope/facts' },
    { label: 'Deps', path: '/scope/deps' },
    { label: 'Changelog', path: '/scope/changelog' },
  ]},
];

const TOPBAR_KPIS = [
  { label: 'Docs', status: 'ok' },
  { label: 'RAG', status: 'ok' },
  { label: 'Claude', value: 'OK', status: 'ok' },
  { label: 'Ollama', status: 'ok' },
];

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <PageLayout domain="docbrain" title="DOCBRAIN" sidebarItems={SIDEBAR} topbarKpis={TOPBAR_KPIS} activePath={location.pathname} onNavigate={p => navigate(p)} masterUrl="https://start.devboxnsa.org">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/library" element={<Library />} />
        <Route path="/library/:id" element={<DocDetail />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/analyze" element={<Analyze />} />
        <Route path="/search" element={<Search />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/agent" element={<Agent />} />
        <Route path="/generate" element={<Generate />} />
        <Route path="/convert" element={<Convert />} />
        <Route path="/pdf-tools" element={<PdfTools />} />
        <Route path="/explorer/*" element={<ExplorerView contexts={cfg?.explorerContexts || []} domain="docbrain" />} />
        <Route path="/nodes" element={<NodesView domain="docbrain" />} />
        <Route path="/graph" element={<GraphView domain="docbrain" />} />
        <Route path="/scope/*" element={<ScopeView domain="docbrain" />} />
      </Routes>
    </PageLayout>
  );
}
